/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type DevopsCreateProjectType from '@jira/spa-apps__devops-connected-project/src/DevopsConnectedProjectDevopsConnectedProject.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyDevopsConnectedProject: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof DevopsCreateProjectType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-devops-connected-project", jiraSpaEntry: "async-devops-connected-project" */ '@jira/spa-apps__devops-connected-project/src/DevopsConnectedProject.tsx'
		),
	),
);

const AsyncDevopsConnectedProject = (): React.JSX.Element => (
	<LazyPage Page={LazyDevopsConnectedProject} pageId="devops-connected-project" shouldShowSpinner />
);

export default AsyncDevopsConnectedProject;
